import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import { StudentAverageDetailsDTO } from "../../models/dtos/student/StudentAverageDetailsDTO";
import { StudentEditionDTO } from "../../models/dtos/student/StudentEditionDTO";
import { TestPercentageDTO } from "../../models/dtos/work-reports/TestPercentageDTO";
import { DateRangeQueryString } from "../../models/query-strings/base/DateRangeQueryString";
import { StudentGeneralInformationView } from "../../models/views/identity/StudentGeneralInformationView ";
import BaseService from "../base/BaseService";

export default class StudentService extends BaseService {
    studyTimeCurrentWeek(): Promise<TitleValue<boolean>[]> {
        return axios.get(`/Students/StudyTimeCurrentWeek`)
            .then(function (response: AxiosResponse<TitleValue<boolean>[], any>) {
                return response.data;
            });
    }

    testPercentage(queryString: DateRangeQueryString): Promise<TestPercentageDTO[]> {
        return axios.get(`/Students/TestPercentage`, { params: queryString })
            .then(function (response: AxiosResponse<TestPercentageDTO[], any>) {
                return response.data;
            });
    }

    getStudentInformation(): Promise<any> {
        return axios.get(`/Students/MyGeneralInformation`)
            .then(function (response: AxiosResponse<StudentGeneralInformationView, any>) {
                return response;
            });
    }

    changeStudentInfo(dto: StudentEditionDTO): Promise<any> {
        return axios.post(`/Students/ChangeStudentInfo`, dto)
            .then(function (response: AxiosResponse<any, any>) {
                return response;
            });
    }

    changeStudentPhoneNumber(dto: StudentEditionDTO): Promise<any> {
        return axios.post(`/Students/ChangeStudentPhoneNumber`, dto)
            .then(function (response: AxiosResponse<any, any>) {
                return response;
            });
    }

    studyTime(query: DateRangeQueryString): Promise<TitleValue<number>[]> {
        return axios.get(`/Students/StudyTime`, { params: query })
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });

    }

    getStudentAverageDetails(userId: string): Promise<StudentAverageDetailsDTO> {
        return axios.get(`/Students/AverageDetails/${userId}`)
            .then(function (response: AxiosResponse<StudentAverageDetailsDTO, any>) {
                return response.data;
            });
    }
}